export default function dateFilter(value, format = 'date') {
    const options = {}

    if (format.includes('YYYY')) {
        options.year = 'numeric'
    } else if ('YY'){
        options.year = '2-digit'
    }

    if (format.includes('MM')) {
        options.month = '2-digit'
    }

    if (format.includes('DD')) {
        options.day = '2-digit'
    }

    
    if (format.includes('hh')) {
        options.hour = '2-digit'
    }

    if (format.includes('mm')) {
        options.minute = '2-digit'
    }

    if (format.includes('ss')) {
        options.second = '2-digit'
    }

    return new Intl.DateTimeFormat('ru-Ru', options).format(new Date(value));
}